import { Component, Input } from '@angular/core';
import { DialpadKeyPressedAction } from '../../../../../store/samwin/client-phone/client-phone.actions';
import { Store } from '@ngxs/store';

@Component({
   selector: 'samweb-dialpad-key',
   templateUrl: './dialpad-key.component.html',
   styleUrls: ['./dialpad-key.component.scss'],
})
export class DialpadKeyComponent {
   @Input()
   public key: string;

   @Input()
   public brickInstanceId: string;

   constructor(private store: Store) {}

   keyPressed() {
      this.store.dispatch(new DialpadKeyPressedAction(this.key, this.brickInstanceId));
   }
}
